import authAPI from "../services/authApi";
import {
  getAccessToken,
  setAccessToken,
  hasAccessToken,
} from "./authStorage";

function parseJwtPayload(token) {
  if (!token) return null;
  try {
    const part = token.split(".")[1];
    if (!part) return null;
    const json = atob(part.replace(/-/g, "+").replace(/_/g, "/"));
    return JSON.parse(json);
  } catch {
    return null;
  }
}

/** Access истекает в ближайшие `leadMs` миллисекунд */
export function isAccessTokenExpiringSoon(token, leadMs = 30 * 60 * 1000) {
  const payload = parseJwtPayload(token);
  if (!payload?.exp) return true;
  return payload.exp * 1000 - Date.now() < leadMs;
}

export function isAccessTokenExpired(token) {
  const payload = parseJwtPayload(token);
  if (!payload?.exp) return true;
  return payload.exp * 1000 <= Date.now();
}

let refreshPromise = null;

/** Обновить access по httpOnly refresh-cookie */
export async function refreshAccessToken() {
  if (refreshPromise) return refreshPromise;
  refreshPromise = authAPI
    .refreshToken()
    .then((data) => {
      if (data?.accessToken) setAccessToken(data.accessToken);
      return data?.accessToken || null;
    })
    .finally(() => {
      refreshPromise = null;
    });
  return refreshPromise;
}

/** Перед запросами / при старте приложения */
export async function proactiveRefreshIfNeeded() {
  const token = getAccessToken();
  if (!token || isAccessTokenExpiringSoon(token)) {
    try {
      return await refreshAccessToken();
    } catch {
      if (!token) return null;
      if (isAccessTokenExpired(token)) {
        return null;
      }
      return token;
    }
  }
  return token;
}

export function startTokenRefreshLoop(intervalMs = 10 * 60 * 1000) {
  const tick = () => {
    if (!hasAccessToken()) return;
    proactiveRefreshIfNeeded().catch(() => {});
  };
  tick();
  return window.setInterval(tick, intervalMs);
}
